<template>
  <div style="margin-top: 10px;width:1000px;margin:0 auto;padding:0 20px;">
    <div v-html="content" class="content"></div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "contentview",
  data() {
    return {
      content: "",
    };
  },
  async mounted() {
    await this.getContentview();
  },
  methods: {
    async getContentview() {
    let type = this.$route.query.type
      let selectField = +type===1?'projectjjcontent':'projectconfirmletter';
      let res = await request({
        method: "get",
        url: "/xmgl/tmpl/getTemplateProjectInfo",
        params: { projectid: this.$route.query.projectid, selectField },
      });
      this.content = +type===1?res.data[0].projectjjcontent:res.data[0].projectconfirmletter
      document.title =  +type===1?`${res.data[0].projectname}的竞价报告`:`${res.data[0].projectname}的竞价结果确认函`
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/table.scss";
@import "../../styles/filelist";


.notice-content {
  overflow: hidden;
  width: 100%;
}

.opinion {
  font-size: 14px;
  margin-top: -8px;
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
    Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.title-A {
  color: #000;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-weight: bold;
}

.content {
  margin-top: 20px;
}

.line-A {
  width: 100%;
  background: #000;
  height: 1px;
  margin-bottom: 1px;
}

.field {
  text-align: left;
  font-size: 16px;
}

.file {
  color: #2f74ff;
  cursor: pointer;
}
</style>
